import { useState } from 'react';
import { FaThLarge, FaUserCircle } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import { isAuth } from '../../helper/auth';

export default function AdminNavbar({ showSidebar, setShowSidebar }) {
    const user = isAuth();
    const location = useLocation().pathname;
    const [flyer, setFlyer] = useState(false);

    const title = location === '/admin' || location === '/admin/'
        ? 'Dashboard'
        : location.replace(/^\/admin\/?/, '').replace(/\//g, ' / ') || 'Dashboard';

    return (
        <nav className="md:bg-white md:backdrop-blur-sm bg-zafu-green md:border-b md:border-gray-200 md:ml-64 py-2 md:py-4 px-4 sticky top-0 z-[45] md:static md:z-auto h-12 md:h-auto flex items-center">
            <div className="container max-w-full mx-auto flex items-center justify-between md:pr-4 w-full">
                {/* Desktop: collapse sidebar */}
                <div className="md:block hidden">
                    <button
                        type="button"
                        onClick={() => setShowSidebar('-left-64')}
                        className="text-zafu-green hover:bg-zafu-cream-dark py-2 px-3 bg-white rounded-full shadow-zafu"
                        aria-label="Tutup sidebar"
                    >
                        <FaThLarge />
                    </button>
                </div>

                {/* Mobile: brand + menu */}
                <div className="md:hidden w-full justify-between flex items-center gap-2">
                    <button
                        type="button"
                        onClick={() => setShowSidebar(showSidebar === 'left-0' ? '-left-64' : 'left-0')}
                        className="text-zafu-green hover:bg-zafu-cream py-2 px-2.5 bg-zafu-cream rounded-full"
                        aria-label="Buka menu"
                    >
                        <FaThLarge />
                    </button>
                    <div className='flex items-center gap-2'>
                        <div className="w-8 h-8 rounded-full bg-zafu-cream text-zafu-green font-display font-bold flex items-center justify-center">
                            Z
                        </div>
                        <span className="text-white text-base font-semibold tracking-wide">ZAFU RESIDENCE</span>
                    </div>
                </div>

                {/* Desktop: breadcrumb + user */}
                <div className="hidden md:flex justify-between items-center w-full ml-2">
                    <h4 className="px-2">
                        <span className="text-zafu-green/50 uppercase text-xs tracking-[0.15em]">Zafu Admin</span>
                        <span className="mx-2 text-zafu-green/30">/</span>
                        <span className="font-display text-zafu-ink text-base capitalize">{title}</span>
                    </h4>
                    <div className="relative">
                        <button
                            type="button"
                            className="rounded-full inline-flex items-center text-sm font-medium hover:bg-zafu-cream-dark px-3 py-1.5 focus:outline-none text-zafu-green"
                            onClick={() => setFlyer(!flyer)}
                        >
                            <FaUserCircle className="text-xl text-zafu-green" />
                            <span className="ml-2 text-zafu-ink">{user?.nama}</span>
                        </button>
                        <div
                            onMouseLeave={() => setFlyer(false)}
                            className={flyer
                                ? 'opacity-100 translate-y-0 transition ease-out duration-200 absolute z-20 right-0 mt-2 w-56'
                                : 'opacity-0 pointer-events-none absolute z-[-1] right-0 mt-2 w-56'}
                        >
                            <div className="rounded-zafu shadow-zafu-lg ring-1 ring-black/5 overflow-hidden bg-white">
                                <div className="px-4 py-3 bg-zafu-cream">
                                    <div className="text-sm font-medium text-zafu-ink">{user?.nama}</div>
                                    <div className="text-xs text-zafu-muted">@{user?.username}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
}
